import { connect } from 'react-redux';

import { actionCreators } from 'dux/apitokens';
import ApiTokenForm from './ApiTokenForm';

const mapDispatchToProps = {
  onTokenCreate: actionCreators.createToken,
};

export default connect(null, mapDispatchToProps)(ApiTokenForm);
